var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyLogoXlg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0007 8.37486L3.64931 2.31126C2.55051 1.84701 1.33398 2.65367 1.33398 3.84652V29.6663C1.33398 30.5868 2.08018 31.333 3.00065 31.333H33.0007C33.9211 31.333 34.6673 30.5868 34.6673 29.6663V9.48C34.6673 8.81018 34.2663 8.20544 33.6493 7.94474L20.316 2.31126C19.2172 1.84701 18.0007 2.65366 18.0007 3.84652V8.37486ZM18.0007 8.37486V13.6616M6.88954 23.833H9.66732M12.4451 23.833H15.2229",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogoXlg);
export default __webpack_public_path__ + "static/media/company-logo-xlg.8d45fe0a0f65acdac5252a6aaa922efc.svg";
export { ForwardRef as ReactComponent };